import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import routes from '../../config/routes';
import { isModeModalSelector, modeModal } from '../../state';
import Header from './Header';
import Sidebar from './Sidebar';
import UpdateControl from '../../components/UpdateControl';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  paddingTop: '56px',

  [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
    paddingTop: '48px',
  },

  [theme.breakpoints.up('sm')]: {
    paddingTop: '64px',
  },
}));

export const Main = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflowX: 'hidden',
  padding: theme.spacing(3),
}));

const routesModeModal = Object.values(routes.protectedRoutes)
  .filter(i => i.modeModal)
  .map(i => i.path);

const ModeModalHandle = () => {
  const isModeModal = useSelector(isModeModalSelector);
  const location = useLocation();
  const shouldShowModeModal = routesModeModal.includes(location.pathname);
  const dispatch = useDispatch();
  useEffect(() => {
    if (shouldShowModeModal !== isModeModal) dispatch(modeModal(shouldShowModeModal));
  }, [shouldShowModeModal, isModeModal, dispatch]);
  return null;
};

const PrivateLayout = () => (
  <Container>
    <UpdateControl />
    <ModeModalHandle />
    <Header />
    <Sidebar />
    <Main data-guide="main-content-area">
      <Outlet />
    </Main>
  </Container>
);

export default PrivateLayout;
